import { Button } from '~/components/ui/button';
import { cn } from '~/utils/cn';

import type { ChatbotAction } from '../../types/chatbot-message.types';

/** Maps our 3-tier action variant onto shadcn Button variants. */
const VARIANT_TO_BUTTON = {
  primary: 'default',
  secondary: 'outline',
  tertiary: 'ghost',
} as const;

interface ActionButtonGroupProps {
  actions: ChatbotAction[];
  /** Invoked with the action id when a button is pressed. Phase 1 uses a console-log stub. */
  onAction?: ((id: ChatbotAction['id']) => void) | undefined;
  /** Lay actions horizontally in a wrap-row instead of a vertical stack. */
  inline?: boolean | undefined;
}

/** Stack of action buttons — primary first, then secondary, then tertiary. Sole interactive surface for workflow decisions. */
export function ActionButtonGroup({ actions, onAction, inline = false }: ActionButtonGroupProps) {
  if (actions.length === 0) return null;
  return (
    <div className={cn(inline ? 'flex flex-wrap gap-2' : 'flex flex-col gap-2')}>
      {actions.map((action) => (
        <Button
          key={action.id}
          variant={VARIANT_TO_BUTTON[action.variant]}
          size="sm"
          className={cn(
            'cursor-pointer',
            !inline && action.variant === 'primary' && 'w-full',
            !inline && action.variant === 'secondary' && 'w-full',
            !inline && action.variant === 'tertiary' && 'w-full',
          )}
          onClick={() => onAction?.(action.id)}
        >
          {action.label}
        </Button>
      ))}
    </div>
  );
}
